import React, { PureComponent } from 'react';

import classNames from 'classnames';
import isFunction from 'lodash/isFunction';
import throttle from 'lodash/throttle';
import PropTypes from 'prop-types';

import './Accordion.scss';

const ACCORDION_CLASS = 'accordion__body';

export default class AccordionToggle extends PureComponent {
  state = {
    maxHeight: 0,
    overflow: 'hidden'
  };

  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    opened: PropTypes.bool,
    maxHeightAuto: PropTypes.bool
  };

  componentDidUpdate(prevProps) {
    if (prevProps.opened !== this.props.opened || this.props.opened) {
      if (prevProps.opened !== this.props.opened) {
        this.setState({ overflow: 'hidden', maxHeight: this.maxHeight });
      } else {
        this.setState({ maxHeight: this.maxHeight });
      }
    }
  }

  componentDidMount() {
    this.setState({ maxHeight: this.maxHeight });
    window.addEventListener(
      'resize',
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      throttle(this.updateHeight, 1000)
    );
  }

  componentWillUnmount() {
    window.removeEventListener(
      'resize',
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      throttle(this.updateHeight, 1000)
    );
  }

  updateHeight = () => {
    const maxHeight = this.maxHeight;

    if (this.state.maxHeight !== maxHeight) {
      this.setState({ maxHeight });
    }
  };

  get maxHeight() {
    // Max-height is the one that set the effect of slide...
    // It should be very big, so any change on the childs would not affect its behavior.
    if (this.props.maxHeightAuto) {
      return 'none';
    }

    const isWrapperOpened = this.props.opened && this.childWrapper;

    return isWrapperOpened
      ? // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        this.childWrapper.scrollHeight * 1.1
      : 0;
  }

  checkOverflow = (event) => {
    event.stopPropagation();
    const { target } = event || {};
    const { className } = target || {};
    const { opened } = this.props;

    if (!className || !isFunction(className.includes)) {
      return;
    }

    if (className.includes(`${ACCORDION_CLASS}`) && opened) {
      this.setState({ overflow: 'initial' });
    }
  };

  render() {
    const { overflow, maxHeight } = this.state;
    const { children, className, opened } = this.props;
    const bodyClass = classNames(ACCORDION_CLASS, className, {
      [`${ACCORDION_CLASS}--active`]: opened
    });

    return (
      <div
        onTransitionEnd={this.checkOverflow}
        key="body"
        className={bodyClass}
        style={{ overflow, maxHeight }}
      >
        <div ref={(node) => (this.childWrapper = node)}>{children}</div>
      </div>
    );
  }
}
